<template>
  <v-card class="elevation-4 pa-3">
    <v-card-title>
      <v-layout justify-center>
        <span v-if="title" class="primary--text font-weight-medium display-2">{{
          title
        }}</span>
        <img v-if="logo" height="100px" :src="logo" />
      </v-layout>
    </v-card-title>

    <v-card-text>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-text-field
          color="primary"
          label="Username"
          type="text"
          v-model="username"
          @keypress.enter="pressEnter"
        >
          <template slot="prepend">
            <m-icon icon="Person" height="24px" width="24px"></m-icon>
          </template>
        </v-text-field>

        <v-text-field
          color="primary"
          label="Password"
          type="password"
          v-model="password"
          @keypress.enter="pressEnter"
        >
          <template slot="prepend">
            <m-icon icon="Lock" height="24px" width="24px"></m-icon>
          </template>
        </v-text-field>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn
        block
        color="primary white--text"
        :loading="loading"
        :disabled="loading || disableLogin()"
        @click="login"
        >Login</v-btn
      >
    </v-card-actions>
    <!-- <v-card-actions>
      <v-btn block color="primary" @click="logout">back</v-btn>
    </v-card-actions>-->
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    loading: Boolean,
    logo: String
  },
  data() {
    return {
      valid: false,
      error: null,
      username: "",
      password: "",
      usernameRules: [
        v => !!v || "Username is required",
        v => v.length >= 4 || "Username must be atleast 4 characters"
      ],
      passwordRules: [v => !!v || "Password is required"]
    };
  },
  components: {},
  methods: {
    disableLogin() {
      if (this.username === "" || this.password === "") {
        return true;
      }
      return false;
    },
    pressEnter() {
      if (!this.disableLogin()) this.login();
    },
    login() {
      this.$emit("login", { username: this.username, password: this.password });
    },
    logout() {
      this.$router.push({
        path: "/"
      });
    },
    clear() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
